import { playRom } from 'app/dux/play/actions';
import { getSessionId } from 'app/dux/session/selectors';
import { AppState } from 'app/store/reducers';
import { connect } from 'react-redux';
import { clearRom, createRom, getRom, setRomValue, updateRom } from './actions';
import RomForm from './Form';
import { getRomRom } from './selectors';

const mapStateToProps = (state: AppState) => {
    return {
        rom: getRomRom(state),
        sessionId: getSessionId(state),
    };
};

const mapDispatchToProps = {
    getRom,
    createRom,
    setRomValue,
    updateRom,
    clearRom,
    playRom,
};

export default connect(mapStateToProps, mapDispatchToProps)(RomForm);
